import { StandardQuizQuestion } from '@/types/quizTypes';

export const ROBOTICS_RL_BASICS_QUIZ: StandardQuizQuestion[] = [
  {
    id: "rl-basic-1",
    question: "What is Reinforcement Learning (RL)?",
    options: [
      "Supervised learning with labels",
      "Learning by trial and error through rewards and penalties",
      "Unsupervised clustering",
      "Database queries"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "Reinforcement Learning is a type of machine learning where an agent learns optimal behavior by interacting with an environment, receiving rewards for good actions and penalties for bad ones.",
    category: "rl-fundamentals",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "rl-basic-2",
    question: "What is a Markov Decision Process (MDP)?",
    options: [
      "A database schema",
      "Mathematical framework for RL with states, actions, and rewards",
      "A programming language",
      "A cloud service"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "MDPs are the mathematical foundation of RL, defining: states (situations), actions (choices), transition probabilities, and rewards. The Markov property means the future depends only on the current state.",
    category: "mdp",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "rl-basic-3",
    question: "What is the difference between exploration and exploitation?",
    options: [
      "No difference",
      "Exploration tries new actions, exploitation uses known best actions",
      "Exploration is faster",
      "Exploitation is cheaper"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Exploration tries new, untested actions to discover better strategies. Exploitation uses the current best-known strategy. Balancing both is crucial for effective learning.",
    category: "exploration-exploitation",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "rl-basic-4",
    question: "What is a reward function in RL?",
    options: [
      "Payment to developers",
      "Function that assigns numerical values to state-action pairs",
      "Database query",
      "User interface element"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "easy",
    explanation: "The reward function defines the objective by assigning numerical rewards/penalties to actions in states. The agent learns to maximize cumulative rewards over time.",
    category: "rewards",
    points: 10,
    type: "multiple-choice"
  },
  {
    id: "rl-basic-5",
    question: "What is Q-learning?",
    options: [
      "A programming language",
      "Model-free RL algorithm learning action-value functions",
      "A database system",
      "A testing framework"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Q-learning learns the expected cumulative reward (Q-value) for taking each action in each state. It updates Q-values based on experience, converging to optimal policy without needing an environment model.",
    category: "algorithms",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "rl-basic-6",
    question: "What is a policy in RL?",
    options: [
      "Security rules",
      "Strategy mapping states to actions",
      "Database permissions",
      "Network protocol"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "A policy defines the agent's behavior by mapping states to actions (or action probabilities). The goal of RL is to learn an optimal policy that maximizes expected cumulative reward.",
    category: "policy",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "rl-basic-7",
    question: "What is the discount factor (gamma) in RL?",
    options: [
      "Price reduction",
      "Parameter controlling weight of future vs immediate rewards",
      "Error rate",
      "Network delay"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Gamma (0 to 1) determines how much future rewards are valued. Gamma=0 means only immediate rewards matter. Gamma near 1 values long-term rewards equally with immediate ones.",
    category: "parameters",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "rl-basic-8",
    question: "What is the difference between on-policy and off-policy learning?",
    options: [
      "No difference",
      "On-policy learns from its own actions, off-policy learns from others",
      "On-policy is faster",
      "Off-policy is simpler"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "On-policy methods (like SARSA) learn from actions taken by their current policy. Off-policy methods (like Q-learning) can learn from any behavior policy, enabling learning from demonstrations or past experience.",
    category: "learning-methods",
    points: 20,
    type: "multiple-choice"
  }
];

export const generateRoboticsRlBasicsQuiz = () => ({
  questions: ROBOTICS_RL_BASICS_QUIZ,
  passThreshold: 75,
  timeLimit: 900,
  category: 'reinforcement-learning'
});
